module.exports = __webpack_public_path__ + "static/img/r3.a88f89a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/r3.png
// module id = RLCF
// module chunks = 1